export const truncateString = (
  str: string,
  maximumLength: number,
  placeholder?: string
) => {
  if (str.length > maximumLength) {
    return `${str.slice(0, maximumLength)} ${
      placeholder ? placeholder : '...'
    }`;
  } else {
    return str;
  }
};

export const lastDotTextRemove = (str: string): string => {
  const indexOfLastDot = str.lastIndexOf('.');
  if (indexOfLastDot !== -1) {
    return str.substring(0, indexOfLastDot);
  } else {
    return str;
  }
};

export const convertBytesToKilobytesOrMegabytes = (bytes: number): string => {
  if (bytes <= 100000) {
    return `${Math.round(bytes / 1000)}kb`;
  }
  return `${Math.round(bytes / (1000 * 1000))} MB`;
};
